export default __webpack_public_path__ + "dff0505d1bfeae92b8647c1bc2713374.png";